<div class="login-page" [class.has-backdrop]="brand.loginBackground">
  <div class="login-backdrop" *ngIf="brand.loginBackground">
    <picture>
      <source srcset="./assets/background.webp" type="image/webp" />
      <img src="./assets/background.jpg" class="login-bg-image" alt="" decoding="async" fetchpriority="low" />
    </picture>
  </div>

  <div class="login-container">
    <div class="login-card">
      <img
        class="login-logo"
        [src]="brand.logo"
        [alt]="brand.productName"
        decoding="async" />

      <h1 class="login-title">Set a new password</h1>
      <p class="login-subtitle">Choose a password for your account</p>

      @if (state === 'no_token') {
        <div class="alert alert-warning login-error" role="alert">
          <i class="bi bi-info-circle login-error-icon" aria-hidden="true"></i>
          <div class="login-error-body">
            <div class="login-error-title">Link invalid or expired</div>
            <p class="login-error-text mb-0">
              Open the reset link from your email again, or request a new link. Use the same site URL as this app.
            </p>
          </div>
        </div>
        <p class="small mb-2">
          <a routerLink="/forgot-password">Request a new reset link</a>
        </p>
        <p class="small mb-0">
          <a routerLink="/login">Back to sign in</a>
        </p>
      }

      @if (state === 'ready') {
        <div *ngIf="error" class="alert alert-danger login-error" role="alert">
          <i class="bi bi-exclamation-circle login-error-icon" aria-hidden="true"></i>
          <div class="login-error-body">
            <p class="login-error-text mb-0">{{ error }}</p>
          </div>
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-form mb-3">
          <div class="form-group">
            <label class="form-label" for="reset-password">New password</label>
            <input
              id="reset-password"
              type="password"
              class="form-control"
              formControlName="password"
              autocomplete="new-password"
              placeholder="At least 6 characters"
              [class.is-invalid]="form.get('password')?.invalid && form.get('password')?.touched" />
            <div
              class="invalid-feedback d-block"
              *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
              Password must be at least 6 characters.
            </div>
          </div>

          <div class="form-group">
            <label class="form-label" for="reset-confirm">Confirm password</label>
            <input
              id="reset-confirm"
              type="password"
              class="form-control"
              formControlName="confirm"
              autocomplete="new-password"
              placeholder="Repeat password"
              [class.is-invalid]="
                (form.get('confirm')?.invalid && form.get('confirm')?.touched) ||
                (form.errors?.['mismatch'] && form.get('confirm')?.touched)
              " />
            <div
              class="invalid-feedback d-block"
              *ngIf="form.errors?.['mismatch'] && form.get('confirm')?.touched">
              Passwords do not match.
            </div>
          </div>

          <button type="submit" class="btn btn-primary login-btn" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
            Save password
          </button>
        </form>

        <p class="small text-center mb-0">
          <a routerLink="/login">Back to sign in</a>
        </p>
      }
    </div>
  </div>
</div>
